export default __webpack_public_path__ + "locales/el-GR/Article.json?hash=7917f19ba098638f31c295936c81e4b2";